import { createContext, useState, useContext } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust the import path as necessary

// Create context
const UserContext = createContext();

// Custom hook for easier access
export const useUser = () => useContext(UserContext);

// Provider component
export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    const fetchUserData = async (token) => {
        try {
            const usersRef = collection(db, 'users');
            const q = query(usersRef, where('token', '==', token));
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                const now = new Date();
                querySnapshot.forEach((doc) => {
                    const userData = doc.data();
                    const tokenCreatedAt = userData.tokenCreatedAt?.toDate();
                    if (tokenCreatedAt && (now - tokenCreatedAt) / (1000 * 60) <= 10) {
                        setUser(userData);
                        console.log('User data fetched successfully:', userData);
                    } else {
                        console.log('Token is expired or invalid!');
                    }
                });
            } else {
                console.log('No matching documents!');
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    };
    return (
        <UserContext.Provider value={{ user, fetchUserData }}>
            {children}
        </UserContext.Provider>
    );
};